import { __chats } from "Utils/Chats/Chats";
import { __debug } from "Utils/Debug/Debug";
import { MsgReceive } from "Utils/Explorer/MsgReceive";
import { IChatMsgAPI_HI, Theme } from "Utils/Interfaces";
import { __callbacks } from "../Callbacks/Callback";
import { __chatQueue } from "../ChatQueue/ChatQueue";
import { __config } from "../Configs/Config";
import { __utils } from "Utils/Utils";
import { __sb } from "Utils/SB/sb";

class Window {
    initWindowVariables = () => {
        this.initChatsKey();
        this.initButtonCloseVar();
        this.initConfigVar();
        this.initNotificationNo();
        this.initThemeVar();
        this.initMsgReceiveVar();
        this.initChatsVar();
    }

    /**
     * Functions listed below enable the communication between the parent frame and the Iframe.
     * This allows for actions in the frame to trigger JS in the main window.
     * Security functions are enabled as the domains will not match, so code cannot be shared directly between the two sources.
     * PostMessage API is used to make communication possible.
     * 
     * Flow for back-and-forth communication is Event Initiator -> Sends message using PostMessage -> 
     * Secondary source has a listener that validates the message and triggers a function within the source ->
     * If data is required at the event initiator, the secondary source then triggers a new postMessage that goes to the initiator where a listener handles the message.
     */

    // When close is triggered, post message from frame to parent window.
    explorerCloseCall = () => {
        window.parent.postMessage({
            'func': 'ButtonClose',
            'message': ''
        }, "*");

        sessionStorage.setItem('last_Chat' + window.location.search.substr(1).split("&")[0].split("=")[1], "0");
    }

    initButtonCloseVar = () => {
        __callbacks.explorerClose.register(this.explorerCloseCall);
    }

    initConfigVar = () => {
        window.onConfigFinish = () => {
            if (__config.configStatus === "finished") {
                __utils.sendMessageToParent('configFinish', __config.getAppConfig());
            } else {
                __callbacks.configFinish.register(() => {
                    __utils.sendMessageToParent('configFinish', __config);
                });
            }
        }
    }

    // This is just a demo function, not needed
    initThemeVar = () => {
        window.setTheme = (theme: Theme) => {
            switch (theme) {
                case "black":
                    return __config.initBlackThemeConfig();
                case "bootstrap":
                    return __config.initBootstrapThemeConfig();
                default:
                    __debug.warn(() => {
                        console.warn("Invalid Theme Given! Initializing black theme...");
                    });
                    __config.initBlackThemeConfig();
                    break;
            }
        }
    }

    // This is just a demo function, not needed
    initMsgReceiveVar = () => {
        window.sendMsg = (chatMsg: IChatMsgAPI_HI) => {
            new MsgReceive(chatMsg);
        }
    }

    /**
     * Initializes the chat variables.
     */
    initChatsVar = () => {
        window.getChats = () => {
            return __chats.getIds();
        }
    }

    /**
     * Initializes the chat keys.
     */
    initChatsKey = () => {
        __sb.loadMissedChats();

        const chatIds = __chats.getIds();

        //Update all previous chats with the new locations - WAY TO RESOURCE HEAVY
        //for (let i = 0; i < chatIds.length; i++) {
        //    const chatId = chatIds[i];
        //    __sb.sendLocation(chatId);
        //}

        const email = window.location.search.substr(1).split("&")[1].split("=")[1];
        if (email !== '') {
            __sb.getContactId("", email, false, "");
        }

        window.parent.postMessage({
            'func': 'getKey',
            'message': ''
        }, "*");
    }

    handleOnConfigFinish = (data: any) => {
        __callbacks.configFinish.trigger(data.config);
        __utils.sendMessageToParent('configFinish', __config.getAppConfig());
    }

    notificationNoCall = (msgNum: any) => {
        window.parent.postMessage({
            'func': 'notificationNum',
            'message': msgNum
        }, "*");
    }

    initNotificationNo = () => {
        window.onNotificationNo = () => {

            __callbacks.onChatMessage(() => {
                const allMsgs = __chatQueue.allMsgs();
                this.notificationNoCall(allMsgs);
            });
        }
    }
}

// Export Window class instance (singleton)
export const __window = new Window();
